// original: https://git.hubteam.com/HubSpot/ui-addon-conversations-settings/blob/a3074a0a75dfbdb23ad52e6a2e9a41799014b3b1/static/js/team/operators/toOptionWithDepth.tsx
import { ROUTING_SOURCE } from '../../shared/constants/routing-source';
import { getTeamContainsFreeUsers } from './getTeamContainsFreeUsers';
import { getId, getName, getNumRoutableUsers } from './getters';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';

// TODO: Remove getDropdownStyle once all consumers migrated to use getSpaceToken for padding
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getDropdownStyle = levelsDeep => {
  return {
    paddingInlineStart: 20 * (levelsDeep - 1)
  };
};

// Map pixel values to space tokens
const getPaddingInlineStartToken = level => {
  switch (level) {
    case 1:
      return [0];
    // 0px
    case 2:
      return [500];
    // 20px
    case 3:
      return [1000];
    // 40px
    case 4:
      return [1300];
    // 60px
    case 5:
      // no 80px token, 1300 (60px) + 500 (20px)
      return [500, 1300];
    case 6:
      // no 100px token, 1300 (60px) + 1000 (40px)
      return [1000, 1300];
    default:
      return [200];
    // default padding
  }
};

// couldn't use an arrow function because Prettier didn't like the generic parameter
function getText(team, routingSource) {
  const numRoutableTeamUsers = getNumRoutableUsers(team);
  return /*#__PURE__*/_jsxs("span", {
    children: [/*#__PURE__*/_jsx("span", {
      children: getName(team)
    }), typeof numRoutableTeamUsers === 'number' ? /*#__PURE__*/_jsx(Text, {
      as: "span",
      color: "icon-core-subtle",
      marginInlineStart: "100",
      typography: "detail-200",
      children: routingSource === true || routingSource === ROUTING_SOURCE.HELP_DESK ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "routing-ui.users-and-teams.team.routableUser",
        options: {
          count: numRoutableTeamUsers
        }
      }) : ` (${numRoutableTeamUsers})`
    }) : null]
  });
}

// couldn't use an arrow function because Prettier didn't like the generic parameter
export function toOptionWithDepth(team, depth, routingSource) {
  return {
    containsFreeUsers: getTeamContainsFreeUsers(team),
    // TODO: Remove dropdownStyle once all consumers migrated to use paddingInlineStart for padding
    dropdownStyle: getDropdownStyle(depth),
    paddingInlineStart: getPaddingInlineStartToken(depth),
    text: getText(team, routingSource),
    title: getName(team) || '',
    value: getId(team) || 0
  };
}